/* eslint-disable react/prop-types */
/* This is the same as the side nav menu renderer and is going to be replaced with a generic solution */

import React from 'react';
import { AdditionalNav } from '@sitebase/web-shell-kit/es/header-kit/additional-nav';
import { AdditionalNavItem } from '@sitebase/web-shell-kit/es/header-kit/additional-nav';


var type = '@sitebase/sub-nav-end';

export default {
  type: type,
  render: function render(_ref, runRenderer) {
    var children = _ref.children,
        data = _ref.data;
    return React.createElement(
      AdditionalNav,
      { key: 'pih.' + type, 'data-test-id': '' + type + (data.id ? '_' + data.id : '') },
      children.map(function (child, index) {
        if (child.type === type) {
          var _ref2 = child.data || {},
              id = _ref2.id,
              label = _ref2.label;

          return React.createElement(
            AdditionalNavItem,
            {
              key: id || label || index,
              'data-test-id': type + '.item' + (id ? '_' + id : ''),
              label: label
            },
            runRenderer(child)
          );
        }
        return runRenderer(child);
      })
    );
  }
};
//# sourceMappingURL=sub-nav-end.js.map